import * as React from 'react';
import Img from '../../../../components/Img';
import { ReactSVG } from 'react-svg';
import Loader from '@/app/forms/Loader';
import { Link } from 'react-router-dom';
import { EventService } from 'services/event/event-service';
import Pagination from "react-js-pagination";
import DropDown from '@/app/forms/DropDown';
import Clone from '@/app/event/components/Clone';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { EventAction } from 'actions/event/event-action';
import { GeneralAction } from 'actions/general-action';
import { connect } from 'react-redux';
import { withRouter } from '../../../helpers/withRouter';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Translation } from "react-i18next";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DashboardTopBar from '@/app/layout/DashboardTopBar';

const EVENTS_LISTING_CALENDAR_VIEW_KEY = 'events_listing_calendar_view';
function readSavedEventsListingCalendarView() {
  try {
    return localStorage.getItem(EVENTS_LISTING_CALENDAR_VIEW_KEY) === '1';
  } catch {
    return false;
  }
}
function persistEventsListingCalendarView(isCalendarView) {
  try {
    localStorage.setItem(EVENTS_LISTING_CALENDAR_VIEW_KEY, isCalendarView ? '1' : '0');
  } catch {
    // ignore quota / private mode
  }
}

class Events extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      preLoader: false,
      sort_by: 'start_date',
      order_by: 'ASC',
      query: '',
      action: 'active_future',

      //pagination
      limit: 10,
      total: '',
      activePage: 1,

      typing: false,
      typingTimeout: 0,

      // POPUP
      clonePopup: false,
      expandedEventId: null,
      isCalendarView: readSavedEventsListingCalendarView()

    }

    //Event
    this.onFieldChange = this.onFieldChange.bind(this);
    this.onSorting = this.onSorting.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.listing();
    document.body.addEventListener('click', this.removePopup.bind(this));
  }

  removePopup = e => {
    if (e.target.className !== 'btn btn_dots active') {
      const items = document.querySelectorAll(".parctical-button-panel .btn");
      for (let i = 0; i < items.length; i++) {
        const element = items[i];
        element.classList.remove("active");
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handlePageChange = (activePage) => {
    this.listing(activePage);
  }

  listing = (activePage = 1) => {
    this.setState({ preLoader: true, clonePopup: false });
    EventService.listing(this.state, activePage).then(
      response => {
        if (response.success) {
          if (this._isMounted) {
            this.setState({
              data: response.data.result,
              activePage: response.data.current_page,
              total: response.data.total,
              preLoader: false
            });
          }
        }
      },
      error => { }
    );
  }

  editEvent = (event) => e => {
    const { dispatch } = this.props;
    dispatch(EventAction.eventState());
    dispatch(GeneralAction.step(1));
    dispatch(EventAction.eventInfo(event));
    dispatch(EventAction.template(''));
    
    // Load event modules immediately when user clicks on an event
    if (event && event.id) {
      EventService.fetchEvent(event.id)
        .then(response => {
          if (response.success && response.data && response.data.modules) {
            // Update the event object with modules and dispatch it again
            const eventWithModules = { ...event, modules: response.data.modules };
            dispatch(EventAction.eventInfo(eventWithModules));
          }
        })
        .catch(error => {
          console.error('Error loading event modules:', error);
        });
    }
    
    // Use dynamic navigation to first available parent menu
    this.navigateToFirstAvailableParent(event.id);
  }

openEvent = (event) => {
    const { dispatch } = this.props;
    dispatch(EventAction.eventState());
    dispatch(GeneralAction.step(1));
    dispatch(EventAction.eventInfo(event));
    dispatch(EventAction.template(''));
    
    // Use dynamic navigation to first available parent menu
    this.navigateToFirstAvailableParent(event.id);
}

sendEmail = (event) => e => {
    const { dispatch } = this.props;
    dispatch(EventAction.eventState());
    dispatch(GeneralAction.step(1));
    dispatch(EventAction.eventInfo(event));
    dispatch(EventAction.template(''));
    dispatch({ type: "invitation", invitation: null });
    this.props.history.push('/event/invitation/send-invitation');
  }

  openDashboard = (event) => e => {
    const { dispatch } = this.props;
    dispatch(EventAction.eventState());
    dispatch(GeneralAction.step(1));
    dispatch(EventAction.eventInfo(event));
    dispatch(EventAction.template(''));
    this.props.history.push(`dashboard`);
  }

  openEmailTemplate = (event) => e => {
    const { dispatch } = this.props;
    dispatch(EventAction.eventState());
    dispatch(GeneralAction.step(1));
    dispatch(EventAction.eventInfo(event));
    dispatch(EventAction.template(''));
    if (event.default_template_id !== undefined) this.props.history.push(`event/template/edit/${event.default_template_id}`);
  }


  openAssignEvent = (event) => e => {
    const { dispatch } = this.props;
    dispatch(EventAction.eventState());
    dispatch(GeneralAction.step(1));
    dispatch(EventAction.eventInfo(event));
    dispatch(EventAction.template(''));
    this.props.history.push(`/admin/assign-events/${event.id}`);
  }
   openSendNews = (event) => e => {
    e.stopPropagation();
    e.preventDefault();
    const { dispatch } = this.props;
    dispatch(EventAction.eventState());
    dispatch(GeneralAction.step(1));
    dispatch(EventAction.eventInfo(event));
    dispatch(EventAction.template(''));
    this.props.history.push(`/event/news/alerts`);
  }
   openReport = (event) => e => {
    console.log('dfdfd')
    const { dispatch } = this.props;
    dispatch(EventAction.eventState());
    dispatch(GeneralAction.step(1));
    dispatch(EventAction.eventInfo(event));
    dispatch(EventAction.template(''));
    this.props.history.push(`/event/reports`);
  }

  createEvent = () => e => {
    const { dispatch } = this.props;
    localStorage.removeItem('from_event_id');
    localStorage.removeItem('event_id');
    localStorage.removeItem('eventState');
    localStorage.removeItem('eventInfo');
    localStorage.removeItem('is_app');
    localStorage.removeItem('is_registration');
    dispatch(EventAction.eventState());
    dispatch(GeneralAction.step(1));
    dispatch(EventAction.eventInfo());
    dispatch(EventAction.template(''));
    this.props.history.push(`/event/create`);
  }

  handleDelete = (event_id) => e => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <Translation>
            {
              t =>
                <div className='app-main-popup'>
                  <div className="app-header">
                    <h4>{t('G_DELETE')}</h4>
                  </div>
                  <div className="app-body">
                    <p>{t('EE_ON_DELETE_ALERT_MSG')}</p>
                  </div>
                  <div className="app-footer">
                    <button className="btn btn-cancel" onClick={onClose}>{t('G_CANCEL')}</button>
                    <button className="btn btn-success"
                      onClick={() => {
                        onClose();
                        EventService.destroy(event_id)
                          .then(
                            response => {
                              if (response.success) {
                                if(this._isMounted){
                                  this.listing(this.state.activePage);
                                }
                              }
                            },
                            error => {
                            }
                          );
                      }}
                    >
                      {t('G_DELETE')}
                    </button>
                  </div>
                </div>
            }
          </Translation>
        );
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { action, order_by, sort_by } = this.state;
    if (action !== prevState.action || order_by !== prevState.order_by || sort_by !== prevState.sort_by) {
      this.listing(1);
    }
  }

  handleChange = input => e => {
    if(e.value === 'expired') {
      this.setState({
        [input]: e.value,
        'order_by': 'DESC'
      });
    } else {
      this.setState({
        [input]: e.value
      });
    }
  }

  onFieldChange(event) {
    const self = this;
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }
    self.setState({
      query: event.target.value,
      typing: false,
      typingTimeout: setTimeout(function () {
        if(self._isMounted){
          self.listing(1)
        }
      }, 1000)
    });
  }

  onSorting(event) {
    this.setState({
      order_by: event.target.attributes.getNamedItem('data-order').value,
      sort_by: event.target.attributes.getNamedItem('data-sort').value,
    });
  }

  handleDropdown = e => {
    e.stopPropagation();
    const items = document.querySelectorAll(".parctical-button-panel .btn");
    for (let i = 0; i < items.length; i++) {
      const element = items[i];
      if (element.classList === e.target.classList) {
        e.target.classList.toggle("active");
      } else {
        element.classList.remove("active");
      }
    }
  };

  handleClose = () => {
    this.setState({
      clonePopup: false
    })
  }

  toggleForms = (eventId) => e => {
    e.stopPropagation();
    this.setState(prevState => ({
      expandedEventId: prevState.expandedEventId === eventId ? null : eventId
    }));
  }

  formatFormDate = (dateValue) => {
    if (!dateValue || dateValue === '0000-00-00 00:00:00' || dateValue === '0000-00-00') {
      return '-';
    }

    const parsedDate = new Date(dateValue.replace(' ', 'T'));
    if (Number.isNaN(parsedDate.getTime())) {
      return '-';
    }

    const day = String(parsedDate.getDate()).padStart(2, '0');
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const year = parsedDate.getFullYear();
    return `${day}-${month}-${year}`;
  }

  formatTicketLeft = (value) => {
    if (value === null || value === undefined || value === '') {
      return '-';
    }
    return value;
  }

  getEventGlobalTicketLeft = (forms = []) => {
    if (!forms.length) {
      return '-';
    }
    return this.formatTicketLeft(forms[0].global_ticket_left);
  }

  toggleCalendarView = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      const next = !prevState.isCalendarView;
      persistEventsListingCalendarView(next);
      return {
        isCalendarView: next,
        expandedEventId: null
      };
    });
  }

  setCalendarView = (isCalendarView) => (e) => {
    e.preventDefault();

    if (this.state.isCalendarView === isCalendarView) {
      return;
    }

    persistEventsListingCalendarView(isCalendarView);
    this.setState({
      isCalendarView,
      expandedEventId: null
    });
  }

  getEventDateValue = (item, key) => {
    const forms = (item && item.forms) || [];
    const eventSettings = (item && item.event && item.event.eventsite_setting) || {};
    const eventData = (item && item.event) || {};

    if (key === 'start') {
      return (
        (forms[0] && forms[0].registration_start_date) ||
        eventSettings.registration_start_date ||
        eventData.start_date
      );
    }

    if (key === 'end') {
      return (
        (forms[0] && forms[0].registration_end_date) ||
        eventSettings.registration_end_date ||
        eventData.registration_end_date
      );
    }

    return (
      (forms[0] && forms[0].cancellation_date) ||
      eventData.cancellation_date ||
      eventSettings.cancellation_date
    );
  }

  getFormsRegisteredTotal = (forms = []) => {
    return forms.reduce((sum, form) => {
      const count = parseInt(form.registered_attendees, 10);
      return sum + (Number.isNaN(count) ? 0 : count);
    }, 0);
  }

  // New method to navigate to first available parent menu
  navigateToFirstAvailableParent = (eventId) => {
    // Import EventService dynamically to avoid circular dependency
    import('services/event/event-service').then(module => {
      const { EventService } = module;
      EventService.getMenuHierarchy(eventId).then(
        (response) => {
          if (response.success) {
            // Check if no menus are available (empty response or all status = 0)
            if (!response.data || response.data.length === 0 || !response.data.some(menu => menu.status === 1)) {
              // Redirect to preview page when no menus are available
              this.props.history.push('/event/preview');
              return;
            }
            
            // Find the first available parent menu (status = 1) with lowest sort_order
            const availableParents = response.data
              .filter(menu => menu.status === 1)
              .sort((a, b) => (a.sort_order || 999) - (b.sort_order || 999));
            
            if (availableParents.length > 0) {
              const firstParent = availableParents[0];
              
              // Use the existing navigation utility functions to get the correct route
              let targetRoute = '';
              
              if (firstParent.alias === 'online_registration_form') {
                // For online registration form, directly navigate to the first available child
                if (firstParent.children && firstParent.children.length > 0) {
                  const availableChildren = firstParent.children
                    .filter(child => child.status === 1)
                    .sort((a, b) => (a.sort_order || 999) - (b.sort_order || 999));
                  
                  if (availableChildren.length > 0) {
                    // Use the route mapping from navigationUtils.js
                    const childRouteMap = {
                      'attendee_fields': '/event/registration/basic-detail-form',
                      'private_address_fields': '/event/registration/private-address-detail-form',
                      'attendee_types': '/event/registration/attendee-type-form',
                      'custom_fields': '/event/registration/custom-fields',
                      'sub_registrations': '/event/registration/sub-registration',
                      'accommodation': '/event/registration/manage/hotels',
                      'gdpr_policy': '/event/registration/gdpr',
                      'terms_conditions': '/event/registration/tos'
                    };
                    
                    const firstChild = availableChildren[0];
                    targetRoute = childRouteMap[firstChild.alias] || '/event/registration/basic-detail-form';
                  } else {
                    targetRoute = '/event/registration/basic-detail-form';
                  }
                } else {
                  targetRoute = '/event/registration/basic-detail-form';
                }
              } else {
                // For other parent menus, use the existing route mapping from navigationUtils.js
                const routeMap = {
                  'event_details': '/event/edit/' + (localStorage.getItem('event_id') || ''),
                  'upload_content': '/event/module/event-module-order',
                  'survey': '/event/manage/surveys',
                  'items_paid': '/event_site/billing-module/payment-methods',
                  'registration_list': '/event_site/billing-module/manage-orders',
                  'branding': '/event/settings/branding'
                };
                
                targetRoute = routeMap[firstParent.alias] || `event/edit/${eventId}`;
              }
              
              // Try to navigate
              try {
                this.props.history.push(targetRoute);
              } catch (error) {
                // Fallback: try using window.location
                window.location.href = targetRoute;
              }
            } else {
              // Redirect to preview page when no parent menus are available
              this.props.history.push('/event/preview');
            }
          } else {
            // Redirect to preview page when API fails
            this.props.history.push('/event/preview');
          }
        },
        (error) => {
          console.error('Error fetching menu hierarchy:', error);
          // Redirect to preview page when there's an error
          this.props.history.push('/event/preview');
        }
      );
    });
  }

  render() {

    this.getSelectedLabel = (item, id) => {
      if (item && item.length > 0 && id) {
        let obj = item.find(o => o.id.toString() === id.toString());
        return (obj ? obj.name : '');
      }
    }
    
    return (
      <Translation>

        {
          t =>
            <div className="container-box main-landing-page">
              <div>
                {this.state.clonePopup &&
                  <Clone
                    onClose={this.handleClose.bind(this)}
                    eventID={this.state.eventID}
                    openEvent={this.openEvent}
                  />
                }
                <div className="top-landing-page">
                  <div className="row d-flex">
                    <div className="col-2">
                      <div className="logo">
                        <Img alt="Plug'n'Play" width="180" src={require("img/logos.svg")} />
                      </div>
                    </div>
                    <div className="col-4">
                      <DashboardTopBar />
                    </div>
                    <div className="col-6">
                      <div className="right-top-header">
                        <input className="search-field" value={this.state.query} name="query" type="text"
                          placeholder={t('G_SEARCH')} onChange={this.onFieldChange} />
                        <label className="label-select-alt">
                          <DropDown
                            label={t('EL_FILTER_BY')}
                            listitems={[
                              { id: 'active_future', name: t('EL_ACTIVE_AND_FUTURE_EVENT') },
                              { id: 'active', name: t('EL_ACTIVE_EVENT') },
                              { id: 'future', name: t('EL_FUTURE_EVENT') },
                              { id: 'expired', name: t('EL_EXPIRED_EVENT') },
                              { id: 'name', name: t('EL_ALL_EVENT') }
                            ]}
                            selected={this.state.action}
                            selectedlabel={this.getSelectedLabel([{ id: 'active_future', name: t('EL_ACTIVE_AND_FUTURE_EVENT') },
                            { id: 'name', name: t('EL_ALL_EVENT') },
                            { id: 'active', name: t('EL_ACTIVE_EVENT') },
                            { id: 'expired', name: t('EL_EXPIRED_EVENT') },
                            { id: 'future', name: t('EL_FUTURE_EVENT') }], this.state.action)}
                            onChange={this.handleChange('action')}
                            required={true}
                          />
                        </label>
                        
                        <a href="#!" className="btn" onClick={this.createEvent()}><i className="icons"><Img
                          alt={t('G_CREATE_EVENT')} src={require("img/ico-plus-white.svg")} /></i>{t('G_CREATE_EVENT')}</a>
                      </div>
                    </div>
                  </div>
                </div>
               
                  <div  className="d-flex align-items-center justify-content-end px-4 pt-4 bg-lightbackground">
                    <Link to="/organizer-email-history" className="d-flex align-items-center  text-decoration-underline">
                      <i className="icons mr-2"><Img alt="E-mail Dashboard" src={require("img/icomailenvelope.svg")} /></i>E-mail Dashboard 
                    </Link>
                    <div className="btn-group btn-group-sm ml-3 border" role="group" aria-label="Event view">
                      <OverlayTrigger overlay={<Tooltip>Default View</Tooltip>}>
                        <button
                          type="button"
                          style={{ backgroundColor: !this.state.isCalendarView ? '#117093' : '#fff', color: !this.state.isCalendarView ? '#fff' : '#117093' }}
                          className={`btn px-2 py-1 ${!this.state.isCalendarView ? 'btn-primary' : 'btn-outline-secondary'}`}
                          onClick={this.setCalendarView(false)}
                          aria-pressed={!this.state.isCalendarView}
                        >
                          <i className="material-symbols-outlined" style={{ fontSize: '20px' }}>
                            menu
                          </i>
                        </button>
                      </OverlayTrigger>
                      <OverlayTrigger overlay={<Tooltip>Calendar View</Tooltip>}>
                        <button
                          type="button"
                          style={{ backgroundColor: this.state.isCalendarView ? '#117093' : '#fff', color: this.state.isCalendarView ? '#fff' : '#117093' }}
                          className={`btn px-2 py-1 ${this.state.isCalendarView ? 'btn-primary' : 'btn-outline-secondary ebs-fill-icon'}`}
                          onClick={this.setCalendarView(true)}
                          aria-pressed={this.state.isCalendarView}
                        >
                          <ReactSVG alt="Calendar view" wrapper="span" className='icons' src={require("img/calendar_month.svg")} />
                        </button>
                      </OverlayTrigger>
                    </div>
                  </div>
                
                <div className="main-data-table pt-0">
                  {this.state.preLoader && <Loader />}
                  {!this.state.preLoader && (
                    <React.Fragment>
                      {this.state.data.length > 0 ? (
                        <div className="flex-data-table">
                          {this.state.isCalendarView ? (
                            <React.Fragment>
                              <div style={{ borderBottom: '1px solid #127093' }} className="flex-header flex-row d-flex rounded-0 mb-2">
                                <div className="data-box" style={{ width: '10%' }}>
                                  <span>{t('EL_ID')}</span>
                                </div>
                                <div className="data-box" style={{ width: '10%' }}>
                                  <span>{t('CREATED_BY')}</span>
                                </div>
                                <div className="data-box" style={{ width: '30%' }}>
                                  <span>{t('EL_NAME')}</span>
                                </div>
                                <div className="data-box" style={{ width: '14%' }}>
                                  <span>{t('TOTAL_REGISTERED')}</span>
                                </div>
                                <div className="data-box" style={{ width: '15%' }}>
                                  <span>{t('REGISTRATION_START_DATE')}</span>
                                </div>
                                <div className="data-box" style={{ width: '15%' }}>
                                  <span>{t('REGISTRATION_END_DATE')}</span>
                                </div>
                                <div className="data-box" style={{ width: '16%' }}>
                                  <span>{t('CANCELLATION_DEADLINE')}</span>
                                </div>
                                <div className="data-box" style={{ width: '16%' }}>
                                  <span>{t('TOTAL_TICKETS')}</span>
                                </div>
                                <div className="data-box box-10">
                                  <span className="small-heading">
                                    {`${this.state.total} ${t('EL_EVENTS')}`}
                                  </span>
                                </div>
                              </div>
                              {this.state.data.map((item, key) => {
                                const isExpanded = this.state.expandedEventId === item.event.id;
                                const totalRegistered = this.getFormsRegisteredTotal(item.forms || []);
                                return (
                                  <React.Fragment key={key}>
                                    <div onClick={this.editEvent(item.event)} className="flex-row d-flex rounded-2" style={{ background: '#EEF2F4', fontSize: '12px' }}>
                                      <div className="data-box" style={{ width: '10%' }}>{item.event.id}</div>
                                      <div className="data-box" style={{ width: '10%' }}>{item.event.organizer_name}</div>
                                      <div className="data-box d-flex align-items-center" style={{ width: '30%' }}>
                                        <span style={{ fontWeight: '600' }}>{item.event.name}</span>
                                        {item.forms && item.forms.length > 0 && (
                                          <OverlayTrigger overlay={<Tooltip>{isExpanded ? 'Hide Forms' : 'View Forms'}</Tooltip>}>
                                            <span
                                              className="ml-2 d-inline-flex align-items-center justify-content-center"
                                              onClick={this.toggleForms(item.event.id)}
                                              role="button"
                                              style={{ cursor: 'pointer', width: '18px', height: '18px', backgroundColor: '#DEDFE1', }}
                                            >
                                              <i className="material-symbols-outlined" style={{ fontSize: '16px', color: '#607D8B' }}>
                                                {isExpanded ? 'expand_less' : 'expand_more'}
                                              </i>
                                            </span>
                                          </OverlayTrigger>
                                        )}
                                      </div>
                                      <div className="data-box" style={{ width: '14%' }}>{totalRegistered}</div>
                                      <div className="data-box" style={{ width: '15%' }}>{this.formatFormDate(this.getEventDateValue(item, 'start'))}</div>
                                      <div className="data-box" style={{ width: '15%' }}>{this.formatFormDate(this.getEventDateValue(item, 'end'))}</div>
                                      <div className="data-box" style={{ width: '16%' }}>{this.formatFormDate(this.getEventDateValue(item, 'cancellation'))}</div>
                                      <div className="data-box" style={{ width: '16%' }}>{this.getEventGlobalTicketLeft(item.forms)}</div>
                                      <div className="data-box box-10" onClick={(e) => e.stopPropagation()} aria-hidden="true" />
                                    </div>
                                    {isExpanded && item.forms && item.forms.length > 0 && (
                                      <div className="flex-row" style={{ background: '#fff', fontSize: '12px', paddingBottom: '10px' }}>
                                        <h3 style={{fontSize: '12px', fontWeight: '600'}} className="mb-0 py-3 border-bottom px-3">FORM DETAILS</h3>
                                        {item.forms.map((form) => (
                                          <div key={form.registration_form_id} className="d-flex py-1" style={{  color: '#3B4D57' }}>
                                            <div style={{ width: '51%', paddingRight: '13px',paddingLeft: '13px' }}>{form.name} form</div>
                                            <div style={{ width: '14%', paddingRight: '13px',paddingLeft: '13px' }}>{form.registered_attendees || 0}</div>
                                            <div style={{ width: '15%', paddingRight: '13px',paddingLeft: '13px' }}>{this.formatFormDate(form.registration_start_date)}</div>
                                            <div style={{ width: '15%', paddingRight: '13px',paddingLeft: '13px' }}>{this.formatFormDate(form.registration_end_date)}</div>
                                            <div style={{ width: '16%', paddingRight: '13px',paddingLeft: '13px' }}>{this.formatFormDate(form.cancellation_date)}</div>
                                            <div style={{ width: '16%', paddingRight: '13px', paddingLeft: '13px' }}>{this.formatTicketLeft(form.form_ticket_left)}</div>
                                            <div style={{ width: 145 }}></div>
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </React.Fragment>
                                );
                              })}
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                          <div className="flex-header flex-row d-flex">
                            <div className="data-box box-1">
                              <span>{t('EL_ID')}</span><i data-order={this.state.order_by === "ASC" ? "DESC" : "ASC"} data-sort="id" onClick={this.onSorting} className="material-symbols-outlined">
                                {(this.state.order_by === "ASC" && this.state.sort_by === "id" ? "keyboard_arrow_down" : (this.state.order_by === "DESC" && this.state.sort_by === "id" ? "keyboard_arrow_up" : "unfold_more"))}
                              </i>
                            </div>
                            <div className="data-box box-2">
                              <span>{t('EL_NAME')}</span><i data-order={this.state.order_by === "ASC" ? "DESC" : "ASC"} data-sort="name" onClick={this.onSorting} className="material-symbols-outlined">
                                {(this.state.order_by === "ASC" && this.state.sort_by === "name" ? "keyboard_arrow_down" : (this.state.order_by === "DESC" && this.state.sort_by === "name" ? "keyboard_arrow_up" : "unfold_more"))}
                              </i>
                            </div>
                            <div className="data-box box-3">
                              <span>{t('EL_DATE')}</span><i data-order={this.state.order_by === "ASC" ? "DESC" : "ASC"} data-sort="start_date" onClick={this.onSorting} className="material-symbols-outlined">
                                {(this.state.order_by === "ASC" && this.state.sort_by === "start_date" ? "keyboard_arrow_down" : (this.state.order_by === "DESC" && this.state.sort_by === "start_date" ? "keyboard_arrow_up" : "unfold_more"))}
                              </i>
                            </div>
                            <div className="data-box box-4">
                              <span>{t('EL_ORGANIZER_NAME')}</span>
                            </div>
                            <div className="data-box box-4">
                              <span>{t('EL_REGISTERED')}</span>
                            </div>
                            <div className="data-box box-5">
                              <span>{t('EL_INVITED')}</span>
                            </div>
                            <div className="data-box box-6">
                              <span>{t('EL_OPEN_RATE')}</span>
                            </div>
                            <div className="data-box box-7">
                              <span>{t('EL_CANCELLED')}</span>
                            </div>
                            <div className="data-box box-8">
                              <span>{t('EL_WAITING_LIST')}</span>
                            </div>
                            <div className="data-box box-9">
                              <span>{t('EL_SEATS_REMAINING')}</span>
                            </div>
                            <div className="data-box box-10">
                              <span className="small-heading">
                                {`${this.state.total} ${t('EL_EVENTS')}`}
                              </span>
                            </div>
                          </div>
                          {this.state.data.map((item, key) => {
                            return (
                              <React.Fragment key={key}>
                                <div onClick={this.editEvent(item.event)} className="flex-row d-flex" style={{ background: item.event.eventsite_setting.payment_type === 1 ? `url(${require("img/img-ribbon-event.svg")}) no-repeat right top #EEF2F4` : '#EEF2F4', backgroundSize: '47px 42px' }} >
                                  <div className="data-box box-1">{item.event.id}</div>
                                  <div className="data-box box-2">{item.event.name}</div>
                                  <div className="data-box box-3">{item.event.start_date_time}</div>
                                  <div className="data-box box-4">{item.owner}</div>
                                  <div className="data-box box-5">{item.registered_attendees}</div>
                                  <div className="data-box box-5 pl-4">{item.invited}</div>
                                  <div className="data-box box-6 pl-4">{item.attendee_invitation_stats.opens}</div>
                                  <div className="data-box box-7 pl-4">{item.cancelled_orders}</div>
                                  <div className="data-box box-8 pl-4">{item.waiting_list_orders}</div>
                                  <div className="data-box box-9 pl-4">{item.seats_remaning}</div>
                                  <div onClick={(e) => e.stopPropagation()} className="data-box box-10">
                                    <div className="panel-nav">
                                      <OverlayTrigger overlay={<Tooltip>{t('EL_EDIT')}</Tooltip>}>
                                        <span onClick={this.editEvent(item.event)}><i
                                          className="icons"><ReactSVG title={t('EL_EDIT')} alt={t('EL_EDIT')} wrapper="span" className={`image-panel-${key}`} src={require("img/ico-edit-gray.svg")} /></i></span>
                                      </OverlayTrigger>
                                      <OverlayTrigger overlay={<Tooltip>{t('EL_SEND_MAIL')}</Tooltip>}>
                                        <span onClick={this.sendEmail(item.event)}>
                                          <i className="icons linestroke"><ReactSVG title={t('EL_SEND_MAIL')} alt={t('EL_SEND_MAIL')} wrapper="span" className={`image-panel-${key}`} src={require("img/ico-email-gray.svg")} /></i>
                                        </span>
                                      </OverlayTrigger>
                                      <OverlayTrigger overlay={<Tooltip>{t('EL_COPY')}</Tooltip>}>
                                        <span onClick={() => this.setState({ clonePopup: true, eventID: item.event.id })}><i className="icons"><ReactSVG title={t('EL_COPY')} alt={t('EL_COPY')} wrapper="span" className={`image-panel-${key}`} src={require("img/ico-copy-gray.svg")} /></i></span>
                                      </OverlayTrigger>
                                      <OverlayTrigger overlay={<Tooltip>{t('EL_DELETE')}</Tooltip>}>
                                        <span onClick={this.handleDelete(item.event.id)}><i
                                          className="icons"><ReactSVG title={t('EL_DELETE')} alt={t('EL_DELETE')} wrapper="span" className={`image-panel-${key}`} src={require("img/ico-delete-gray.svg")} /></i></span>
                                      </OverlayTrigger>
                                      <div className="parctical-button-panel">
                                        <div className="dropdown">
                                          <span onClick={this.handleDropdown.bind(this)} className="btn btn_dots">
                                          </span>
                                          <div className="dropdown-menu">
                                            <button className="dropdown-item" onClick={this.openReport(item.event)}>
                                              <ReactSVG title={t('EL_REPORTS')} alt={t('EL_REPORTS')} wrapper="span" className='icons' src={require("img/ico-reports-gray.svg")} /> {t('EL_REPORTS')}
                                            </button>
                                            <button className="dropdown-item" onClick={this.openDashboard(item.event)}>
                                              <ReactSVG title={t('EL_ANALYTICS')} alt={t('EL_ANALYTICS')} wrapper="span" className='icons' src={require("img/ico-analytic-gray.svg")} />{t('EL_ANALYTICS')}
                                            </button>
                                            <button className="dropdown-item" onClick={this.openEmailTemplate(item.event)}>
                                              <ReactSVG title={t('EL_EMAIL_TEMPLATES')} alt={t('EL_EMAIL_TEMPLATES')} wrapper="span" className='icons' src={require("img/ico-envelop-gray.svg")} />{t('EL_EMAIL_TEMPLATES')}
                                            </button>
                                            <button className="dropdown-item" onClick={this.openSendNews(item.event)}>
                                              <ReactSVG title={t('EL_SEND_NEWS')} alt={t('EL_SEND_NEWS')} wrapper="span" className='icons' src={require("img/ico-sendnew-gray.svg")} />{t('EL_SEND_NEWS')}
                                            </button>

                                            {this.props.auth.data !== undefined && (this.props.auth.data.user.parent_id === 0 || this.props.auth.data.user.id === item.event.owner_id) ? (
                                              <button className="dropdown-item" onClick={this.openAssignEvent(item.event)}>
                                                <ReactSVG title={t('EL_ASSIGN_ADMIN')} alt={t('EL_ASSIGN_ADMIN')} wrapper="span" className='icons' src={require("img/admin.svg")} />{t('EL_ASSIGN_ADMIN')}
                                              </button>) : ''}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </React.Fragment>
                            );
                          })}
                            </React.Fragment>
                          )}
                        </div>
                      ) : (this.state.query === "" ? (
                        <Link className="start-creating-event" to="/event/create"><Img
                          alt="Start Creating Event" src={require("img/start-creating-event.svg")} /></Link>
                      ) : (
                          <React.Fragment>
                            <div style={{ textAlign: 'center' }}>
                              <Img width="850px" src={require('img/noresult.svg')} alt="No Result" />
                            </div>
                          </React.Fragment>
                        )
                        )}
                      {this.state.total > this.state.limit ? (
                        <nav className="page-navigation" aria-label="navigation">
                          <Pagination
                            hideFirstLastPages={true}
                            prevPageText="keyboard_arrow_left"
                            linkClassPrev="material-symbols-outlined"
                            nextPageText="keyboard_arrow_right"
                            linkClassNext="material-symbols-outlined"
                            innerClass="pagination"
                            itemClass="page-item"
                            linkClass="page-link"
                            activePage={this.state.activePage}
                            itemsCountPerPage={this.state.limit}
                            totalItemsCount={this.state.total}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange}
                          />
                        </nav>
                      ) : ''}
                    </React.Fragment>
                  )}
                <div style={{height: '80px'}}></div>
                </div>
              </div>
            </div>
        }
      </Translation>
    );
  }
}

function mapStateToProps(state) {
  const { event, auth } = state;
  return {
    event, auth
  };
}

export default connect(mapStateToProps)(withRouter(Events));
